import styled from 'config/theme';

export const RelativeContainer = styled.div`
  position: relative;
`;
